import ReactDOM from 'react-dom';
import React from 'react';
import { getIsAuthenticated } from '../../../domain/hidden-data-provider';
import ExclamationMark from '../../../ui/svg/common/exclamation-mark';
import { sendGAEvent } from '../../../domain/marketing/gtm-provider';
import { getPersonalizationProperty } from '../../personalization/domain/personalization-provider';

export const initSbsPaymentFailedMobile = () => {
    const $rootMobile = document.getElementById('header-m-sbs-payment-failed');
    if (!$rootMobile) return;

    const isLoggedIn = getIsAuthenticated();
    if(!isLoggedIn) return;

    const userHasSbsPaymentIssue = getPersonalizationProperty('hasSBSPaymentIssue') as boolean;
    if(!userHasSbsPaymentIssue) return;

    const sendEvent = () => {
        sendGAEvent('SBS Payment Issue', 'Click Mobile Top');
    };

    ReactDOM.render(
        <React.StrictMode>
            <a
                href="/account/products"
                onClick={sendEvent}
                className="text-center mr-6 flex items-center justify-center no-underline bg-red-100 text-xs rounded px-2"
                style={{
                    background: '#FF0000',
                    width: '22px',
                    height: '22px',
                    borderRadius: '100%',
                }}>
                <ExclamationMark
                    title="Subscription Payment Failed"
                    width="3"
                    height="15"
                />
            </a>
        </React.StrictMode>,
        $rootMobile
    );
};